import { useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useGetReviewTicketListingQuery } from '../../api/reviewTicketAPI';
import { ActiveChatContext } from '../../context/ActiveChatContext';
import { logMessage } from '../../logger';
import Error from '../Error';
import Popup from '../Popup';
import Timestamp from '../Timestamp';
import { Container, StyledList } from './styles';
import ReviewTicket from '../../containers/ReviewTicket';

const CustomerReviewTicket = ({ isPreview, setIsPreview, setIsPreviewTicket }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [activeChat] = useContext(ActiveChatContext);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [selectedReview, setSelectedReview] = useState(null);
  const {
    data: listTickets,
    error: errorFetch,
    isLoading,
  } = useGetReviewTicketListingQuery(activeChat?._id?.$oid ?? '', { skip: !activeChat?._id?.$oid });

  const handleListItemClick = (event, index) => {
    logMessage(event);
    setSelectedIndex(index);
    const ticket = listTickets?.data?.[index];
    setSelectedTicket(ticket?.report ?? null);
    setSelectedReview(ticket?.review ?? null);
    setIsPreview(true);
    setShowPopup(true);
  };
  const closePopup = () => {
    setIsPreview(false);
    setIsPreviewTicket(false);
    setShowPopup(false);
  };
  return (
    <Container>
      {showPopup && (
        <Popup
          isPreviewTicket={true}
          setIsPreviewTicket={setIsPreviewTicket}
          handleClose={closePopup}
        >
          {(errorFetch && 'error' in errorFetch && <Error message={errorFetch.error} />) || (
            <ReviewTicket
              onClose={() => {}}
              isPreview={isPreview}
              setIsPreview={setIsPreview}
              isPreviewTicket={true}
              content={selectedTicket}
              review={selectedReview}
              customer={activeChat}
            />
          )}
        </Popup>
      )}
      <h4>
        <FormattedMessage
          id="messages.customerReviewTickets.title"
          defaultMessage="Review Tickets"
        />
      </h4>
      <StyledList>
        {isLoading ? (
          <div>
            <FormattedMessage id="messages.loading" defaultMessage="Loading..." />
          </div>
        ) : Array.isArray(listTickets?.data) && listTickets?.data?.length > 0 ? (
          listTickets.data.map((item, index) => (
            <ListItemButton
              key={item._id?.$oid || item.id || `review-ticket-${index}`}
              selected={selectedIndex === index}
              onClick={(event) => handleListItemClick(event, index)}
            >
              <ListItemText>
                {index + 1}.{' '}
                <Timestamp
                  showDate={item.createdAt?.date}
                  customerDataStoreTimezone={item.store?.timezone}
                />{' '}
                {item.user?.name || ''}
              </ListItemText>
            </ListItemButton>
          ))
        ) : (
          <h4>
            <FormattedMessage
              id="messages.customerTickets.no_tickets"
              defaultMessage="No Review Tickets"
            />
          </h4>
        )}
      </StyledList>
    </Container>
  );
};
export default CustomerReviewTicket;
